import React from 'react';

const ReviewPendingView: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[40vh] gap-4 text-center px-6">
    <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center">
      <span className="text-3xl" role="img" aria-label="Under review">⏳</span>
    </div>
    <h2 className="text-xl font-semibold text-gray-800">Your submission is under review</h2>
    <p className="text-gray-500 max-w-md">
      The artist or their team needs to review your information before the next step.
      You can check back later — your progress has been saved.
    </p>
  </div>
);

export default ReviewPendingView;
